// UserEdit.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardLayout from '../Dashboard/layout';

const UserEdit = () => {
  const { id } = useParams();  // Get the user id from the URL
  const [user, setUser] = useState(null);
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Simulating a fetch request for a single user
    const fetchUser = async () => {
      try {
        const users = [
          { id: 1, name: 'John Doe', role: 'Mentor', email: 'john@example.com', status: 'Active' },
          { id: 2, name: 'Jane Smith', role: 'Mentee', email: 'jane@example.com', status: 'Inactive' },
          { id: 3, name: 'Michael Brown', role: 'Mentor', email: 'michael@example.com', status: 'Blocked' },
          { id: 4, name: 'Emily White', role: 'Mentee', email: 'emily@example.com', status: 'Active' },
          { id: 5, name: 'Samuel Green', role: 'Mentor', email: 'samuel@example.com', status: 'Inactive' },
          { id: 6, name: 'Linda Gray', role: 'Mentee', email: 'linda@example.com', status: 'Active' }
        ];
        const user = users.find((user) => user.id === parseInt(id));
        setUser(user);
        setName(user.name);
        setRole(user.role);
        setEmail(user.email);
        setStatus(user.status);
      } catch (error) {
        console.error('Failed to fetch user:', error);
      }
    };

    fetchUser();
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulating the user update
    alert('User details updated!');
    // In a real-world app, you'd send the updated data to the server here
    navigate(`/user-view/${id}`);
  };

  if (!user) {
    return <p>Loading...</p>;
  }

  return (
    <DashboardLayout>
      <h1>Edit User</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Name:</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div>
          <label>Role:</label>
          <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="Mentor">Mentor</option>
            <option value="Mentee">Mentee</option>
          </select>
        </div>
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div>
          <label>Status:</label>
          <select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
            <option value="Blocked">Blocked</option>
          </select>
        </div>
        <button type="submit">Save Changes</button>
      </form>
    </DashboardLayout>
  );
};

export default UserEdit;
